<div class="bg-surface border rounded-md overflow-hidden flex text-sm">
  <div
    class="min-w-16 w-16 flex flex-col justify-center items-center text-center bg-accent"
  >
    <div class="flex flex-col m-2">
      <p class="font-bold">{{ orderItem()?.quantity }}</p>
      <p class="text-xs">{{ orderItem()?.unit?.name }}</p>
    </div>
  </div>
  <div class="flex flex-row m-2 w-full gap-1">
    <div class="flex flex-col w-full">
      <p>{{ orderItem().product.number }}</p>
      <p class="font-bold">
        {{ orderItem().product.name }}
      </p>
      <p class="text-light">
        {{ orderItem().product.matchcode }}
      </p>
      <p>{{ orderItem().product.supplierItemNumber }}</p>
    </div>
    <div class="flex flex-row m-2 w-full gap-8 items-center justify-end">
      <p class="text-left w-full text-danger">
        {{ orderItem().discount ? orderItem().discount + '%' : '' }}
      </p>
      <p
        class="text-left w-full"
        [class.text-danger]="orderItem().price.pricePerUnit < 0"
      >
        {{ orderItem().price.pricePerUnit.toString().replace('.', ',') }}€
      </p>
      <p
        class="text-left font-bold w-full"
        [class.text-danger]="orderItem().price.price < 0"
      >
        {{ orderItem().price.price.toString().replace('.', ',') }}€
      </p>
      @if (canEdit()) {
        <button
          type="button"
          class="border-accent border rounded-md items-center flex hover:bg-hover"
          (click)="editOrderItem.emit()"
        >
          <soft-icon name="fa-regular fa-pen-to-square text-accent" class="p-2" />
        </button>
      }
      @if (canDelete()) {
        <button
          type="button"
          class="border-danger border rounded-md items-center flex hover:bg-hover"
          (click)="removeOrderItem.emit()"
        >
          <soft-icon name="fa-regular fa-trash-can text-danger" class="p-2"></soft-icon>
        </button>
      }
    </div>
  </div>
</div>
